// La nouvelle interface, épurée (9 octobre 2026) : Explorer et le Sonar d'un
// format (`pages/epure/ESonar.vue`). Les mots du Sonar déjà écrits pour l'écran
// classique (`sonar.statut`, `sonar.mots`, `sonar.titre`, `sonar.relecture`…)
// se lisent dans `sonar` ; ne sont ici que ceux des maquettes et du choix des
// publics.
export default {
  ariane: 'Fil d’Ariane',
  explorer: {
    sousTitre: 'Une question ouverte, posée aux publics que vous choisissez',
    vosEtudes: 'Vos études',
  },
  format: {
    titre: 'Sonar',
    sousTitre: 'Une question sur {titre}, posée à ses cibles : ce qu’elles choisissent, ce qu’elles préfèrent, ce qu’elles en disent',
    poseeA: 'Posée à vos cibles, {cibles}',
    poseeAuPanel: 'Posée au panel du format',
    changer: 'changer',
    changerAria: 'Changer les cibles de {titre}',
    aucune: 'Pas encore de question sur {titre}.',
  },
  // La piste d'une lecture de passage (19 octobre 2026) : ses réponses préparées.
  piste: {
    titre: 'Les réponses préparées : {titre}',
    aide: 'Le panel choisira entre ces réponses ; décochez celles à écarter. Vous relisez encore l’étude avant de la lancer.',
    oublier: 'Ne pas les garder',
    saison: 'Ce que le panel saura de la saison',
    saisonAide: 'Des faits, sans chiffre d’audience ni avis : le panel le lit avant de répondre. Videz-le pour qu’il n’en sache rien.',
  },
  question: {
    libelle: 'Votre question',
    exemples: 'Par exemple :',
    publicRequis: 'Choisissez au moins un public à interroger.',
  },
  heure: {
    libelle: 'Interroger comme le',
    maintenant: 'Maintenant',
    revenir: 'Revenir à maintenant',
    passee: 'Les jumeaux répondent comme à cet instant.',
    avenir: 'L’étude partira à cette heure.',
    commeLe: 'Comme le {quand}',
    partira: 'Elle partira le {quand}.',
  },
  publics: {
    libelle: 'À qui la poser',
    choisis: 'Choisis :',
    aucun: 'Aucun public choisi pour l’instant.',
    compte: '{n} sur {max} au plus',
    toutRetirer: 'Tout retirer',
    retirer: 'Retirer {nom}',
    rechercher: 'Rechercher',
    rechercherDans: 'Rechercher parmi : {famille}',
    aucunResultat: 'Aucun public ne correspond.',
    maximum: '{max} publics au plus : retirez-en un pour en choisir un autre.',
    termine: 'Terminé',
    choisisDans: 'aucun choisi | {n} choisi | {n} choisis',
    chargement: 'Les publics se lisent…',
    illisibles: 'Les publics n’ont pas pu se lire.',
    fermes: 'Le choix des publics n’est pas ouvert à votre compte.',
    aucunOuvert: 'Aucun public interrogeable n’est encore ouvert à votre compte.',
    famille: {
      // Les villes de la simulation : leurs jumeaux répondent (4 novembre 2026).
      simulation: 'Villes',
      pays: 'Pays',
      chaine: 'Chaînes',
      plateforme: 'Plateformes',
      jeunes: 'Publics jeunes',
      thematique: 'Verticales',
      // L'électorat d'un pays, pour qui a Polis (11 octobre 2026).
      politique: 'Politique',
      programme: 'Publics des programmes',
      autres: 'Autres publics',
    },
  },
  statut: {
    rendu: 'Rendue',
  },
  vote: {
    questionPosee: 'La question posée au panel',
  },
  relecture: {
    auPlus: 'Au plus {nb} dans la liste : retirez-en quelques-uns.',
  },
  // La lecture fine d'une étude sur les jumeaux (4 novembre 2026)
  fine: {
    affiner: 'Affiner',
    replier: 'Replier',
    toutLePanel: 'Tout le panel',
    effacer: 'Tout effacer',
    retirer: 'Retirer : {critere}',
    part: '{pct} des habitants, environ {personnes} personnes',
    partSeule: '{pct} des habitants',
    tropPeu: 'Trop peu de répondants dans ce filtre pour le lire.',
    personne: 'Personne ne correspond à ce filtre.',
    interrogerGroupe: 'Interroger ce groupe',
    questionsSeul: {
      q1: 'Qu’est-ce qui vous a fait répondre ça ?',
      q2: 'Racontez-moi une de vos soirées : où êtes-vous, et que regardez-vous ?',
      q3: 'Qu’est-ce qui pourrait vous faire changer d’avis ?',
    },
    parlerAUn: 'Parler à l’un d’eux',
    ventiler: 'Ventiler par',
    age: 'Âge',
    de: 'De',
    a: 'à',
    ans: 'ans',
    ageDe: '{lo} à {hi} ans',
    ageDes: 'Dès {lo} ans',
    ageJusque: 'Jusqu’à {hi} ans',
    criteres: {
      sexe: 'Sexe',
      statut: 'Activité',
      csp: 'Catégorie',
      diplome: 'Diplôme',
      logement: 'Logement',
      revenu: 'Revenu net mensuel',
      transport: 'Se déplace',
      nationalite: 'Nationalité',
      quartier: 'Quartier',
      vote: 'Présidentielle 2022, 1er tour',
    },
    axes: {
      age: 'Âge',
      sexe: 'Sexe',
      statut: 'Activité',
      csp: 'Catégorie',
      diplome: 'Diplôme',
      logement: 'Logement',
      revenu: 'Revenu',
      quartier: 'Quartier',
      vote: 'Vote 2022',
    },
    ages: { a8_14: '8-14 ans', a15_24: '15-24 ans', a25_34: '25-34 ans', a35_49: '35-49 ans', a50_64: '50-64 ans', a65plus: '65 ans et plus' },
    sexe: { f: 'Femmes', h: 'Hommes' },
    statut: { actif: 'En emploi', chomeur: 'Au chômage', retraite: 'Retraités', etudiant: 'Étudiants', eleve: 'Élèves', inactif: 'Autres inactifs' },
    csp: { cadre: 'Cadres', intermediaire: 'Professions intermédiaires', employe: 'Employés', ouvrier: 'Ouvriers', artisan_commercant: 'Artisans, commerçants', agriculteur: 'Agriculteurs' },
    diplome: { aucun: 'Sans diplôme ou brevet', cap: 'CAP, BEP', bac: 'Bac', bac3: 'Bac+2, bac+3', bac5: 'Bac+5 et plus' },
    logement: { proprietaire: 'Propriétaires', prive: 'Locataires du privé', hlm: 'Locataires HLM', meuble: 'En meublé', gratuit: 'Logés gratuitement' },
    revenu: { sans: 'Sans revenu', rmoins1500: 'Moins de 1 500 €', r1500a2500: '1 500 à 2 500 €', r2500a4000: '2 500 à 4 000 €', rplus4000: '4 000 € et plus' },
    transport: { transports: 'En transports', voiture: 'En voiture', velo: 'À vélo', marche: 'À pied', deux_roues: 'En deux-roues', aucun: 'Ne se déplace pas' },
    nationalite: { francaise: 'Française', etrangere: 'Étrangère' },
    abstention: 'Abstention',
    // Qui parle, quand on parle à l'un d'eux : « Femme, 34 ans, cadre, 11e »
    qui: {
      f: 'Femme',
      h: 'Homme',
      fille: 'Fille',
      garcon: 'Garçon',
      ans: '{n} ans',
      statut: { f: { chomeur: 'au chômage', retraite: 'retraitée', etudiant: 'étudiante', eleve: 'élève', inactif: 'sans activité' }, h: { chomeur: 'au chômage', retraite: 'retraité', etudiant: 'étudiant', eleve: 'élève', inactif: 'sans activité' } },
      csp: { f: { cadre: 'cadre', intermediaire: 'profession intermédiaire', employe: 'employée', ouvrier: 'ouvrière', artisan_commercant: 'artisane ou commerçante', agriculteur: 'agricultrice' }, h: { cadre: 'cadre', intermediaire: 'profession intermédiaire', employe: 'employé', ouvrier: 'ouvrier', artisan_commercant: 'artisan ou commerçant', agriculteur: 'agriculteur' } },
      unJumeau: 'L’un d’eux',
    },
  },
}
